import { useEffect } from "react";
import * as React from "react";
import { useLocation } from "react-router-dom";
import sessionStorageService from "src/services/sessionStorageService";
import { selectAuth } from "src/features/authSlice";
import { useAppSelector } from "src/app/hooks";
import { mixpanelTrackPageView } from "src/services/mixpanelService";

// Records the user's current route so a same-session re-login can resume where
// they were. Stored in sessionStorage on purpose -- see sessionStorageService
// for why this must NOT persist across browser sessions.
const RouteChangeListener: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const { acctId, username } = useAppSelector(selectAuth);

  // Product analytics: record every SPA route change as a page view.
  useEffect(() => {
    mixpanelTrackPageView(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    // NotFound sets this flag so we don't record the 404/access-denied page as
    // the resume target -- resuming to it would just bounce back to a dead route.
    const skipThisRoute = sessionStorageService.getItem("storeLastLocation");
    if (skipThisRoute) {
      sessionStorageService.removeItem("storeLastLocation");
      return;
    }

    if (!location.pathname.startsWith("/login") && location.pathname !== "/") {
      if (username) {
        const lastLocationKey = `lastLocation_${acctId}_${username}`;
        const fullUrl = location.pathname + location.search;
        sessionStorageService.setItem(lastLocationKey, fullUrl);
      }
    }
  }, [acctId, username, location]);

  return <>{children}</>;
};

export default RouteChangeListener;
